import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
export const SitePadding = 18;
export const SitePaddingDesktop = 80;
export const SiteWidth = 1760;
export const SiteWidthNarrow = 860;
const Container = styled.div `
  ${setCssVar('sitePadding', `${SitePadding}px`)};
  ${setCssVar('siteWidth', `${SiteWidth}px`)};

  margin-left: auto;
  margin-right: auto;
  max-width: calc(${cssVar('siteWidth')} + (${cssVar('sitePadding')} * 2));
  padding-left: ${cssVar('sitePadding')};
  padding-right: ${cssVar('sitePadding')};
  width: 100%;

  @media ${from(Device.DesktopSmall)} {
    ${setCssVar('sitePadding', `${SitePaddingDesktop}px`)};
  }

  ${({ width }) => {
    switch (width) {
        case 'default':
            return css `
          @media ${from(Device.DesktopLarge)} {
          }
        `;
        case 'narrow':
            return css `
          @media ${from(Device.TabletLarge)} {
            ${setCssVar('siteWidth', `${SiteWidthNarrow}px`)};
          }
        `;
    }
}}
`;
export default {
    Container,
};
